<template>
    <div class="deal_index_box">
        <!-- 交易管理》充值订单 -->
        <div class="deal_title">
            <div>交易管理<span>》</span>充值訂單</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box" v-show="detailsTF" v-loading="inquireTF">
            <div class="deal_content_title">充值訂單</div>
            <div class="deal_content">
                <el-tabs class="deal_content_tab" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane class="deal_content_tab_first" label="訂單列表查詢" name="first">
                        <!-- 訂單列表查詢 -->
                        <div class="datetime_box">
                            交易時間：
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center"
                                value-format="timestamp"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </div>
                        <!-- 充值類型： -->
                        <div>
                            充值類型：  
                            <el-select v-model="paymentValue" placeholder="所有充值類型">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            </el-select>
                        </div>
                        <!-- 订单狀態： -->
                        <div>
                            订单狀態：  
                            <el-select v-model="transactionValue" placeholder="所有订单狀態">
                            <el-option
                            v-for="item in options2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            </el-select>
                        </div>
                        <!-- 充值金額 -->
                        <div class="money_box">
                            充值金額：<el-input class="money_input money_input01" placeholder="" v-model="money1" clearable></el-input>
                           <span>至</span><el-input class="money_input" placeholder="" v-model="money2" clearable></el-input>
                        </div>
                        <!-- 订单號： -->
                        <div class="paymentorder_box">
                            订单號：<el-input class="" placeholder="" v-model="paymentorderVal" clearable></el-input>
                        </div>
                        <!-- UID查詢 -->
                        <div class="uid_box" v-show="this.$store.state.uid == '1' ">
                            UID查詢：<el-input class="" placeholder="" v-model="uidVal" clearable></el-input>
                        </div>
                        <!-- 查詢按钮 -->
                        <div class="inquire_button">
                        <el-button type="primary" @click="inquireFun()">查詢</el-button>
                        </div>
                        <!-- 表单 -->
                        <div class="table_download"> 
                            <span>匯出紀錄</span>
                            <span><img src="../../../../assets/img/login/logindeal/icon_xls.png" alt="" @click="ExcelFun('exportexcel')"></span>
                            <span><img src="../../../../assets/img/login/logindeal/icon_txt.png" alt="" @click="ExcelFun('exporttxt')"></span>
                        </div>
                        <div>
                            <!-- 表单头 -->
                            <div class="table_header">
                                <div class="table_date">交易時間</div>
                                <div class="table_uid">UID</div>
                                <div class="table_merchantorder">商戶訂單號</div>
                                <div class="table_paymentorder">充值状态</div>
                                <div class="table_branch">到账时间</div>
                                <div class="table_paytime">充值類型</div>
                                <div class="table_paymenttype">訂單金額</div>
                                <div class="table_status">手机号</div>
                                <div class="table_money">户号地区</div>
                                <div class="table_paymoney">户号类型</div>
                                <div class="table_service">充值户号</div>
                                <div class="table_operation">操作</div>
                            </div>
                            <!-- 表单内容 -->
                            <div class="table_maxbox" v-for="(list, index) of pagelist" :key="index" v-show="currentPage == (index+1)">
                                <div class="table_content" v-for="item of list" :key="item.id">
                                    <div class="table_date">{{item.createtime}}</div>
                                    <div class="table_uid">{{item.uid}}</div>
                                    <div class="table_merchantorder">{{item.order_no}}</div>
                                    <div class="table_paymentorder">
                                        <!-- <span>{{item.pay_no}}</span> -->
                                        <span class="txt_tf">{{item.status}}</span>
                                    </div>
                                    <div class="table_branch">{{item.paytime}}</div>
                                    <div class="table_paytime">{{item.recharge_type_name}}</div>
                                    <div class="table_paymenttype">{{item.amount}}</div>
                                    <div class="table_status">
                                        <span>{{item.mobile}}</span>
                                    </div>
                                    <div class="table_money">{{item.account_area}}</div>
                                    <div class="table_paymoney">{{item.account_type}}</div>
                                    <div class="table_service">{{item.account}}</div>
                                    <div class="table_operation">
                                        <span @click="detailsFun(item)">查看</span>
                                        <!-- <i class="el-icon-view"></i> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 表单分页列表 -->
                            <div class="table_pagination">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[100, 500, 1000]"
                                    :page-size="pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalNumber"
                                    >
                                </el-pagination>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="依訂單編號查詢應" name="second">
                        依訂單編號查詢應
                    </el-tab-pane> -->
            </el-tabs>
            </div>
        </div>
        <!-- 內容-end -->
        <!-- 訂單詳情 -->
        <order-details v-show="!detailsTF" @detailsFun="detailsFun()"></order-details>
        <!-- deal_index_box -->
    </div>
</template>

<script>
import axios from 'axios';
import OrderDetails from '../../common/OrderDetails.vue';
import { type } from 'os';

export default {
    name: 'LoginDealIndex',
    metaInfo: {
        title: '台易購-交易中心', // set a title
        meta: [{ // set meta
        name: 'keyWords',
        content: '台灣，購物中心，電子商務，電商平台'
        }, {
        name: 'Description',
        content: '台易購是一個電商平台。'
        }]
    },
    data() {
        return {
            activeName: "first",
            // 查询时候加载状态
            inquireTF: false,
            // 訂單詳情切換
            detailsTF: true,
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            uidVal: '',
            dateValue: '',
            payValTF: false,
            start_time: '',
            end_time: '',
            // 所有付款類型
            options: [{
                value: '',
                label: '所有付款類型'
            }, {
                value: '1',
                label: '话费'
            }, {
                value: '2',
                label: '油费'
            },{
                value: '3',
                label: '电费'
            }],
            paymentValue: '',
            // 所有交易狀態
            options2: [{
                value: '',
                label: '所有交易狀態'
            }, {
                value: '0',
                label: '充值中'
            }, {
                value: '1',
                label: '充值成功'
            },{
                value: '-1',
                label: '充值失败'
            }],
            transactionValue: '',
            // 所有銀行
            options3: [ {
                value: '',
                label: '所有銀行'
            }, {
                value: 'CoinPay',
                label: 'CoinPay'
            }, {
                value: 'Chouzhou',
                label: '稠州銀行'
            }],
            money1: '',
            money2: '',
            paymentorderVal: '',
            // 表单
            tableData:[],
            totalNumber: 0,
            currentPage: 1,
            pageSize: 100,
            pagelist:[],
        // return
        }
    },
    components: {
        OrderDetails
    },
    methods: {
        aa(){
            console.log(this.paymentValue);
        },
        handleClick(tab, event) {
            // console.log(tab, event);
        },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.pagelist = this.pagesFun(val);
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        },
        //判斷付款類型 
        typeFun(index){
            if(index == '1'){
                return '掃碼支付'
            }
            if(index == '2'){
                return 'Web支付'
            }
            if(index == '3'){
                return 'APP支付'
            }
            if(index == '4'){
                return '其他'
            }
        },
        //判斷交易類型 
        optionsFun(index){
            if(index == '1'){
                return '已付款'
            }
            if(index == '0'){
                return '未付款'
            }
        },
        //判斷撥款類型 
        statusFun(index){
            if(index == '1'){
                return '已撥款'
            } else {
                return '未撥款'
            }
        },
        // FUN-分頁顯示
        pagesFun(number){
            let pages=[];
            this.tableData.forEach((item,index)=>{
                var page=Math.floor(index/number);
                if(!pages[page]){
                    pages[page]=[];
                }
                pages[page].push(item);
            })
            return pages;
        },
        // FUN-订单查询
        inquireFun(){
            // 支付單號
            if(this.paymentorderVal != ''){
                this.payValTF = false;
            }

            if( this.payValTF == true ){
                return
            }

            // 交易时间：
            if( this.dateValue ){
                this.end_time = this.dateValue[1].toString();
                this.end_time = this.end_time.substring(0, 10);
                this.start_time = this.dateValue[0].toString();
                this.start_time = this.start_time.substring(0, 10);
                // 交易狀態:
                // this.transactionValue = '1';
            } else {
                this.dateValue = '';
                this.end_time = '';
                this.start_time = '';
            }


            this.inquireTF = true;
            axios.get(this.$store.state.axiosRechargeUrl, {
                params: {
                    start_time: this.start_time,
                    end_time: this.end_time,
                    recharge_type: this.paymentValue,
                    status: this.transactionValue,
                    start_money: this.money1,
                    end_money: this.money2,
                    order_no: this.paymentorderVal,
                    uid: this.uidVal ? this.uidVal : this.$store.state.uid
                }
            }).then((res) => {
                console.log(res.data);
                this.inquireTF = false;
                this.currentPage = 1;
                 if(res.data.message){
                    if(res.data.status){
                        this.tableData = res.data.message.list;
                        console.log(this.tableData);
                        this.totalNumber = Number(res.data.message.total);
                        this.pagelist = this.pagesFun(this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error',
                            duration: 1000
                        });
                    }
                 } else {
                    this.$message({
                        showClose: true,
                        message: '沒有數據',
                        type: 'error',
                        duration: 1000
                    });
                    this.tableData = [];
                    this.pagelist = this.pagesFun(this.pageSize);
                    this.totalNumber = 0;
                }
            })
        },
        // FUN-EXCEL下載
        ExcelFun(hxr){
            let txt_url = '';
            let charset = '';
            let uidvalue = '';
            // 简体还是繁体
            if (navigator.language === "zh-TW"){
                charset = "BIG5";
            } else {
                charset = "GBK";
            }
            // 是否UID
            if (this.uidVal == ''){
               uidvalue = this.$store.state.uid;
            } else {
               uidvalue = this.uidVal;
            }
            // 下载：
            txt_url = this.$store.state.axiosInquireUrl1
                +'&uid='+uidvalue
                +'&end_time='+this.end_time
                +'&start_time='+this.start_time
                +'&type='+this.paymentValue
                +'&status='+this.transactionValue
                +'&start_money='+this.money1
                +'&end_money='+this.money2
                +'&payno='+this.paymentorderVal
                +'&charset='+charset
                +'&do='+hxr;

            window.location.href = txt_url;
        },
        // FUN-訂單詳情
        detailsFun(item){
            this.detailsTF = !this.detailsTF;
            this.$store.commit('changeDetails',item);
        }
    },
    computed: {
        
    },
    created(){
        // this.inquireTF = true;
        
        // 時間：
        let start = new Date(new Date(new Date().toLocaleDateString()).getTime());
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        start = start.getTime();
        let end = new Date(new Date(new Date().toLocaleDateString()).getTime());
        end = end.getTime();
        let list = [];
        list[0] = start;
        list[1] = end;
        this.dateValue = list;
        this.inquireFun();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .txt_tf {
        text-align: center;
    }
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 0 20px;
        padding-top: 26px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        min-width: 960px;
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px 0;
    }
    .pay_box .el-input {
        margin-left: 4px;
        width: 214px;
    }
    .paymentorder_box .el-input {
        margin-left: 4px;
        width: 214px;
    }
    .uid_box .el-input {
        margin-left: 8px;
        width: 214px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .table_download span {
        display: inline-block;
        margin: 0 10px;
    }
    .table_download span img {
        cursor: pointer;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        text-align: center;
    }
    .table_maxbox >div+div {
        border-top: 1px solid #e7e7e7;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
    }
     .table_date {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
    }
     .table_uid {
        box-sizing: border-box;
        width: 4%;
        padding: 0 10px;
    }
    .table_merchantorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 9%;
        padding: 0 10px;
        /* min-width: 160px; */
    }
    .table_paymentorder {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 9%;
        padding: 0 10px;
    }
    .table_paymentorder > span+span {
        margin-top: 4px;
    }
    .table_branch {
        box-sizing: border-box;
        width: 6%;
        padding: 0 10px;
        min-width: 77px;
    }
    .table_paytime {
        box-sizing: border-box;
        width: 7%;
        padding: 0 10px;
        /* min-width: 77px; */
    }
    .table_paymenttype {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
        /* min-width: 77px; */
    }
    .table_status {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        width: 9%;
        padding: 0 10px;
        /* min-width: 66px; */
    }
    .table_status > span+span {
        margin-top: 4px;
    }
    .table_money {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
        min-width: 66px;
    }
    .table_paymoney {
        box-sizing: border-box;
        width: 9%;
        padding: 0 10px;
        /* min-width: 66px; */
    }
    .table_service {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
        min-width: 66px;
    }
    /* .table_content .table_money {
        text-align: right;
    } */
    .table_operation {
        padding: 0 10px;
    }
    .table_operation span {
        margin-right: 10px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
        cursor: pointer;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }




    @media screen and (max-width:1599px){
        .table_paytime {
            width: 11%;
        }
    }
</style>
